import { connect } from 'react-redux';
import * as Actions from '../../../redux/actions';
import Sidebar from '../Sidebar';
import {combineProductsWithGroupsAndServices} from '../../../redux/selectors';

const {
  switchDocsMainContentToInfo,
  switchDocsMainContentToSwagger,
  setDocsSwaggerApi,
  setDocsApiInfo
} = Actions;

const mapDispatchToProps = {
  switchDocsMainContentToInfo,
  switchDocsMainContentToSwagger,
  setDocsSwaggerApi,
  setDocsApiInfo
};

export default connect(
  state => ({combinedProductAndServices: combineProductsWithGroupsAndServices(state),
    isStatic: state.products.infoContent.isstatic
  }),
  mapDispatchToProps
)(Sidebar);

